import { render, staticRenderFns } from "./Dashboard-def.vue?vue&type=template&id=f0d02768&"
import script from "./Dashboard-def.vue?vue&type=script&lang=js&"
export * from "./Dashboard-def.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports